const initialState = {
    backgrounds: null
};

export default function BackgroundsReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_BACKGROUNDS": {
            return {
                ...state,
                backgrounds: action.backgrounds
            };
        }

        default: {
            return state;
        }
    }
}